// extracted by mini-css-extract-plugin
module.exports = {"title":"terms-and-conditions-module--title--HXUtI","content":"terms-and-conditions-module--content--1Q8l6"};